/* RSP contact embeds and newsletter modal. No contact data is read or stored here. */
(() => {
  if (window.rspPodFormsLoaded) return;
  window.rspPodFormsLoaded = true;
  const key = 'rsp-pod-newsletter-dismissed-session-v2';
  let dismissedThisPage = false;
  const initialized = new WeakSet();
  const init = (root = document) => {
    root.querySelectorAll('[data-rsp-popup]').forEach(dialog => {
      if (initialized.has(dialog) || typeof dialog.showModal !== 'function') return;
      initialized.add(dialog);
      const editor = dialog.dataset.editor === 'true';
      const delay = editor ? 0 : Math.min(60, Math.max(0, Number(dialog.dataset.delay) || 0));
      const isDismissed = () => {
        if (dismissedThisPage) return true;
        try { return sessionStorage.getItem(key) === '1'; } catch { return false; }
      };
      let previousFocus;
      const remember = () => {
        if (editor) return;
        dismissedThisPage = true;
        try { sessionStorage.setItem(key, '1'); } catch {}
      };
      const close = () => { if (dialog.open) dialog.close(); };
      dialog.querySelector('[data-rsp-close]')?.addEventListener('click', close);
      dialog.addEventListener('close', () => {
        remember();
        if (previousFocus?.isConnected) previousFocus.focus();
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      });
      const timer = setTimeout(() => {
        if (!dialog.isConnected || dialog.open || document.hidden) return;
        if (!editor && isDismissed()) return;
        // Avoid interrupting another dialog or a customer typing into a form.
        if (document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return;
        previousFocus = document.activeElement;
        dialog.showModal();
      }, delay * 1000);
      dialog.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => clearTimeout(timer), { once: true });
    });
  };
  // Accept height updates only from the actual Jotform iframe and trusted origin.
  window.addEventListener('message', event => {
    if (event.origin !== 'https://form.jotform.com' || typeof event.data !== 'string') return;
    const match = /^setHeight:(\d+)(?::|$)/.exec(event.data);
    if (!match) return;
    const height = Math.min(6000, Math.max(350, Number(match[1])));
    document.querySelectorAll('iframe[data-rsp-form]').forEach(frame => {
      if (event.source === frame.contentWindow) frame.style.height = `${height}px`;
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
